import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import { ROOM_STATUS } from 'shared/constants';
import { AlertNotice, TimeZone, SimpleModal } from 'shared/components';
import './RoomManualTiming.scss';
import { CloseRoomSection } from 'features/task-management/index';

const getPauseTime = (pauseList) => {
  let totalTime = 0;
  pauseList.forEach((pause) => {
    const pauseTime = moment(pause.unpauseDateTime).diff(moment(pause.pauseDateTime), 'seconds');
    totalTime = totalTime + parseInt(pauseTime / 60) + (pauseTime % 60 > 0 ? 1 : 0);
  });
  return totalTime;
};

const isTimeCompleted = (timersTasks) => !timersTasks.some((timer) => !timer.startDateTime);

class RoomManualTiming extends Component {
  constructor(props) {
    super(props);

    this.state = {
      timingWarningOpen: false,
    };

    this.renderWeb = this.renderWeb.bind(this);
    this.renderMobile = this.renderMobile.bind(this);
    this.goToCloseRoomPage = this.goToCloseRoomPage.bind(this);
    this.closeWarningModal = this.closeWarningModal.bind(this);
  }

  goToCloseRoomPage(closeFlag) {
    const { timersTasks, roomStatus } = this.props;

    if (isTimeCompleted(timersTasks) || closeFlag || roomStatus.status === ROOM_STATUS.closed) {
      this.setState({
        timingWarningOpen: false,
      });
      this.props.goToCloseRoomPage();
    } else {
      this.setState({
        timingWarningOpen: true,
      });
    }
  }

  renderWeb() {
    const { timersTasks, eventId, roomId } = this.props;

    return (
      <div className="d-table table-container show-desktop">
        <div className="table-header">
          <div className="table-cell">{this.props.t('taskManagement.manualTimer.testName')}</div>
          <div className="table-cell">{this.props.t('taskManagement.manualTimer.startTime')}</div>
          <div className="table-cell">{this.props.t('taskManagement.manualTimer.totalPause')}</div>
          <div className="table-cell">
            {this.props.t('taskManagement.manualTimer.30minWarning')}
          </div>
          <div className="table-cell">{this.props.t('taskManagement.manualTimer.5minWarning')}</div>
          <div className="table-cell">{this.props.t('taskManagement.manualTimer.stopTime')}</div>
          <div className="table-cell" />
        </div>
        {timersTasks.map((timer, idx) => (
          <div className="table-row" key={timer.startTask.id}>
            <div className="table-cell">{timer.startTask.name}</div>
            <div className="table-cell">
              {timer.startDateTime ? moment(timer.startDateTime).format('hh:mm a') : '-'}
            </div>
            <div className="table-cell">
              {timer.roomTimerPause
                ? this.props.t('taskManagement.manualTimer.time', {
                    time: getPauseTime(timer.roomTimerPause),
                  })
                : '-'}
            </div>
            <div className="table-cell">
              {timer.warning30
                ? timer.warning30.completeDateTime
                  ? moment(timer.warning30.completeDateTime).format('hh:mm a')
                  : '-'
                : 'N/A'}
            </div>
            <div className="table-cell">
              {timer.warning5
                ? (timer.warning5.completeDateTime
                    ? moment(timer.warning5.completeDateTime).format('hh:mm a')
                    : '-') || '-'
                : 'N/A'}
            </div>
            <div className="table-cell">
              {timer.stopDateTime ? moment(timer.stopDateTime).format('hh:mm a') : '-'}
            </div>
            <div className="table-cell p-0">
              {!timer.startDateTime && (
                <Link
                  to={`/test-event/${eventId}/room/${roomId}/manual-timer/${idx}`}
                  href={`/test-event/${eventId}/room/${roomId}/manual-timer/${idx}`}
                  className="ml-0 btn btn-action">
                  {this.props.t('taskManagement.manualTimer.addTime')}
                </Link>
              )}
            </div>
          </div>
        ))}
      </div>
    );
  }

  renderMobile() {
    const { timersTasks, eventId, roomId } = this.props;

    return (
      <div className="hide-desktop mobile-version">
        {timersTasks.map((timer, idx) => (
          <div className="timing-element" key={timer.startTask.id}>
            <div className="fw-bold pb-3">{timer.startTask.name}</div>
            <div className="timer-row">
              <span className="fw-bold">
                {this.props.t('taskManagement.manualTimer.startTime')}
              </span>
              <span className="float-end">
                {timer.startDateTime ? moment(timer.startDateTime).format('hh:mm a') : '-'}
              </span>
            </div>
            <div className="timer-row">
              <span className="fw-bold">
                {this.props.t('taskManagement.manualTimer.totalPause')}
              </span>
              <span className="float-end">
                {timer.roomTimerPause
                  ? this.props.t('taskManagement.manualTimer.time', {
                      time: getPauseTime(timer.roomTimerPause),
                    })
                  : '-'}
              </span>
            </div>
            <div className="timer-row">
              <span className="fw-bold">
                {this.props.t('taskManagement.manualTimer.30minWarning')}
              </span>
              <span className="float-end">
                {timer.warning30
                  ? (timer.warning30.completeDateTime
                      ? moment(timer.warning30.completeDateTime).format('hh:mm a')
                      : '-') || '-'
                  : 'N/A'}
              </span>
            </div>
            <div className="timer-row">
              <span className="fw-bold">
                {this.props.t('taskManagement.manualTimer.5minWarning')}
              </span>
              <span className="float-end">
                {timer.warning5
                  ? (timer.warning5.completeDateTime
                      ? moment(timer.warning5.completeDateTime).format('hh:mm a')
                      : '-') || '-'
                  : 'N/A'}
              </span>
            </div>
            <div className="timer-row">
              <span className="fw-bold">{this.props.t('taskManagement.manualTimer.stopTime')}</span>
              <span className="float-end">
                {timer.stopDateTime ? moment(timer.stopDateTime).format('hh:mm a') : '-'}
              </span>
            </div>
            <div className="">
              {!timer.startDateTime && (
                <Link
                  to={`/test-event/${eventId}/room/${roomId}/manual-timer/${idx}`}
                  href={`/test-event/${eventId}/room/${roomId}/manual-timer/${idx}`}
                  className="ml-0 btn btn-action w-100">
                  {this.props.t('taskManagement.manualTimer.addTime')}
                </Link>
              )}
            </div>
          </div>
        ))}
      </div>
    );
  }

  closeWarningModal() {
    this.setState({
      timingWarningOpen: false,
    });
  }

  render() {
    const { timingWarningOpen } = this.state;
    const { roomStatus } = this.props;
    const isClosed = roomStatus.status === ROOM_STATUS.closed;
    const isInactive = roomStatus.status === ROOM_STATUS.inactive;

    return (
      <div className="room-manual-timing-container mt-4">
        <h5 className="">{this.props.t('taskManagement.roomManualTimerTitle')}</h5>
        {isClosed ? (
          <AlertNotice message={this.props.t('taskManagement.manualTimer.closeRoomMessage')} />
        ) : (
          <div>
            <div className="display-flex">
              <div className="subtitle">
                {this.props.t('taskManagement.manualTimer.roomDashboardSubtitle')}
              </div>
              <TimeZone />
            </div>
            {this.renderWeb()}
            {this.renderMobile()}
          </div>
        )}
        {!isInactive && (
          <CloseRoomSection
            goToCloseRoomPage={() => this.goToCloseRoomPage(false)}
            isClosed={isClosed}
          />
        )}
        <SimpleModal
          icon="error_outline"
          isOpen={timingWarningOpen}
          onCancel={this.closeWarningModal}
          onConfirm={() => this.goToCloseRoomPage(true)}
          confirmLabel={this.props.t('common.labels.yes')}
          cancelLabel={this.props.t('common.labels.no')}
          headline={this.props.t('taskManagement.manualTimer.noTimingWarning')}
        />
      </div>
    );
  }
}

RoomManualTiming.propTypes = {
  timersTasks: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  eventId: PropTypes.string.isRequired,
  roomId: PropTypes.string.isRequired,
  roomStatus: PropTypes.shape({
    status: PropTypes.string,
  }).isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(RoomManualTiming);
